<template>
  <div class="video-container">
    <div class="video-cover">
      <img 
        class="play-btn" 
        :src="require('@/assets/images/play.png')" 
        alt="play" 
        @click="toggleVideo"
        v-show="!isPlaying"
      />
      <video 
        :controls="isPlaying" 
        :src="videoUrl" 
        ref="video"
        @ended="handleVideoEnded"
        @pause="handleVideoPause"
      ></video>
    </div>
    <div class="video-info">
      <div class="video-title">{{ videoTitle }}</div>
      <div class="video-duration">{{ videoDate }} <span>|</span> {{ videoDuration }}</div>
      <div class="rools">比赛规则</div>
      <div 
        v-for="(rule, index) in rules" 
        :key="index" 
        class="rools-item"
      >
        {{ rule }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    videoUrl: {
      type: String,
      required: true
    },
    videoTitle: {
      type: String,
      default: '视频标题'
    },
    videoDate: {
      type: String,
      default: ''
    },
    videoDuration: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isPlaying: false,
      videoCompleted: false
    };
  },
  methods: {
    toggleVideo() {
      if (this.isPlaying) {
        this.pauseVideo();
      } else {
        this.playVideo();
      }
    },
    
    playVideo() {
      this.$refs.video.play();
      this.isPlaying = true;
      this.$emit('play-state-changed', true);
    },
    
    pauseVideo() {
      this.$refs.video.pause();
      this.isPlaying = false;
      this.$emit('play-state-changed', false);
    },
    
    handleVideoEnded() {
      this.isPlaying = false;
      this.videoCompleted = true;
      this.$emit('video-completed', true);
      this.$emit('play-state-changed', false);
    },
    
    handleVideoPause() {
      this.isPlaying = false;
      this.$emit('play-state-changed', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.video-container {
  display: flex;
  border-radius: 20px;
  background: linear-gradient(212.11deg, rgba(255, 244, 210, 0.16) -13.652%, rgba(252, 247, 243, 0.61) 89.556%);
  
  .video-cover {
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.16);
    width: 546px;
    height: 300px;
    position: relative;
    overflow: hidden;
    
    .play-btn {
      z-index: 9;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 68px;
      height: 68px;
      cursor: pointer;
    }
    
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }
  }
  
  .video-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 50px;
    
    .video-title {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 8px;
    }
    
    .video-duration {
      margin-bottom: 32px;
      line-height: 22px;
      color: #808080;
      display: flex;
      align-items: center;
      
      span {
        line-height: 22px;
        margin: 0 16px;
        font-size: 10px;
        color: #BCBCBC;
      }
    }
    
    .rools { 
      line-height: 24px;
      color: #595959;
      font-weight: 500;
    }
    
    .rools-item {
      line-height: 24px;
      color: #595959;
      
      &::before {
        content: '•';
        margin-right: 8px;
      }        
    } 
  }
}
</style> 